import React from "react";
import { AdditionalHoursItem } from "../../../models/weeklyTimeline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";

interface AdditionalHoursItemProps {
  item: AdditionalHoursItem;
  bottomLastMargin: string;
}

const AdditionalHoursItemComponent: React.FC<AdditionalHoursItemProps> = ({
  item,
  bottomLastMargin,
}) => {
  return (
    <div className={`mt-1 flex flex-col ${bottomLastMargin}`}>
      <div className="flex flex-row">
        <div className="flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full bg-[#ff9f0a]">
          <FontAwesomeIcon className="h-4 w-4 max-h-4 max-w-4 text-white" icon={faClock} />
        </div>
        <h1 className="ml-3 flex items-center justify-center text-sm text-[#212322]">
          {item.hour.createUser?.firstName} {item.hour.createUser?.lastName}{" "}
          submitted Additional Hours
        </h1>
      </div>
    </div>
  );
};

export default AdditionalHoursItemComponent; 